import { Col, Image, Input, Radio, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import './style.css'
import { Button, Loader, Modal, ProfileImage, Text, TextField } from '../../components'
import { useNavigate, useParams } from 'react-router'
import { ApiCaller, Colors, Fonts, Utils } from '../../config'
import { useDispatch, useSelector } from 'react-redux'
import { DisputeActions } from '../../store/actions'
import { FaPhoneAlt } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { ImNotification } from "react-icons/im";


const DisputeDetail = () => {

    const { id } = useParams();
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        values: {
            subject: '',
            message: ''
        },
        errors: {
            subject: '',
            message: ''
        }
    })

    const [radioValue, setRadioValue] = useState('');
    const [partialModal, setPartialModal] = useState(false);
    const [partialValues, setPartialValues] = useState({
        sp: 0,
        su: 0
    })
    const [partialValueError, setPartialValueError] = useState({
        sp: '',
        su: ''
    })


    const { disputeDetail, isLoading } = useSelector(state => state?.DisputesManagementReducer);
    console.log(disputeDetail?.status)
    useEffect(() => {
        dispatch(DisputeActions.disputeDetail(id))
    }, [id])


    const emailSubmitter = async () => {
        try {
            let bookingId = disputeDetail?.bookingId;
            let res = await ApiCaller.Post('/admin/dispute/send-email', { ...formValues.values, bookingId });
            if (res?.status == 200) {
                Utils.showSnackBar({
                    message: res?.data?.data?.message,
                })
                setFormValues({ values: { subject: "", message: "" }, errors: { subject: "", message: "" } });
            }
            else {
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            console.log(error)
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }

    const disputeResolver = async () => {
        try {
            let res = await ApiCaller.Patch(`/admin/dispute/${id}`, {
                status: "resolved",
                adminAction: radioValue,
                suPercentage: radioValue == 'PARTIAL' ? parseInt(partialValues.su) : 0,
                spPercentage: radioValue == 'PARTIAL' ? parseInt(partialValues.sp) : 0
            });

            if (res?.status == 200) {
                Utils.showSnackBar({
                    message: res?.data?.data?.message,
                })
                setRadioValue('')
                setPartialValues({
                    sp: 0,
                    su: 0
                })
            }
            else {
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }


    const emailFormSubmitHandler = async (e) => {
        e.preventDefault();
        if (!formValues?.values?.subject && !formValues?.values?.message) {
            setFormValues({ ...formValues, errors: { message: 'Message is required', subject: 'Subject is required' } })
        }
        else if (!formValues?.values?.subject) {
            setFormValues({ ...formValues, errors: { message: "", subject: 'Subject is required' } })
        }
        else if (!formValues?.values?.message) {
            setFormValues({ ...formValues, errors: { subject: "", message: 'Message is required' } })
        }
        else {
            await emailSubmitter();
        }
    }

    const disputeHandler = async () => {
        if (radioValue) {
            await disputeResolver()
        }
    }

    const radioSelection = (e) => {
        setRadioValue(e.target.value)
    }

    const partialModalHandler = () => {
        setPartialModal(true)
    }

    const partialValuesSubmitHandler = () => {
        if (!partialValues.sp && !partialValues.su) {
            setPartialValueError({
                sp: 'value is required',
                su: 'value is required',
            })
            return
        }
        else if (!partialValues.su) {
            setPartialValueError({
                sp: '',
                su: 'value is required',
            })
            return
        }
        else if (!partialValues.sp) {
            setPartialValueError({
                su: '',
                sp: 'value is required',
            })
            return
        }
        else {
            setPartialValueError({
                su: '',
                sp: '',
            })
            let suPercentage = parseInt(partialValues.su);
            let spPercentage = parseInt(partialValues.sp);
            if (suPercentage + spPercentage !== 100) {
                Utils.showSnackBar({
                    message: "The sum must be equal to 100",
                    severity: "error",
                });
                return
            }
            else {
                let suPercentage = String(partialValues.su).search('%');
                let spPercentage = String(partialValues.sp).search('%');
                if (suPercentage !== -1 || spPercentage !== -1) {
                    Utils.showSnackBar({
                        message: "The number is allowed only",
                        severity: "error",
                    });
                    return
                }
                setPartialModal(false)
            }
        }
    }

    return (
        <Row className='w-full detail-container'>
            {
                isLoading ?
                    <Row className='loader-container' align='center' justify='center'>
                        <Col span={24} className='loader'>
                            <Loader.Circular />
                        </Col>
                    </Row>
                    :
                    <>
                        <Col lg={11} md={11} sm={24} className='detail-subcontainer-1' >
                            <div>
                                <h2>Disputed By: <span>*</span></h2>
                                <span>{disputeDetail?.disputeBy?.email ? disputeDetail?.disputeBy?.email : '-'}</span>
                            </div>
                            <div>
                                <h2>Disputed Detail: <span>*</span></h2>
                                <p className='dispute-detail'>
                                    {disputeDetail?.disputeDetail ? disputeDetail?.disputeDetail : '-'}
                                </p>
                            </div>
                            <div>
                                <h2>Supporting Evidence: <span>*</span></h2>
                                <div className='image-container'>
                                    <Image
                                        toolbarRender={false}
                                        className='w-full h-full'
                                        src={disputeDetail?.evidence ? disputeDetail?.evidence : "-"}
                                    />
                                </div>
                                <a href={disputeDetail?.evidence ? disputeDetail?.evidence : "-"} download className='download-btn'>Download Evidence</a>
                            </div>
                        </Col>

                        <Col className='divider'></Col>

                        <Col lg={11} md={11} sm={24} className='detail-subcontainer-2'>

                            <h2>Comment (send a message)</h2>

                            <form onSubmit={emailFormSubmitHandler}>
                                <div>
                                    <label>Subject <span>*</span></label>
                                    <input
                                        type='text'
                                        name='subject'
                                        className='input-class'
                                        placeholder='Subject line'
                                        value={formValues?.values.subject}
                                        onChange={(e) =>
                                            setFormValues({ ...formValues, values: { ...formValues.values, subject: e.target.value } })}
                                    />
                                    {formValues.errors.subject && <p className='error-p'>{formValues.errors.subject}</p>}
                                </div>

                                <div>
                                    <label>Message <span>*</span></label>
                                    <textarea
                                        name='message'
                                        rows={4}
                                        placeholder='your message'
                                        className='text-area-class'
                                        value={formValues?.values.message}
                                        onChange={(e) =>
                                            setFormValues({ ...formValues, values: { ...formValues.values, message: e.target.value } })}
                                    />
                                    {formValues.errors.message && <p className='error-p'>{formValues.errors.message}</p>}
                                </div>

                                <Button.Basic
                                    type='submit'
                                    text={'Send Email'}
                                    className={'submit-btn'}
                                />
                            </form>

                            <div className='dispute-selection'>
                                <label className='dispute-label'>Actions <span>*</span></label>
                                <Radio.Group name="radiogroup" className='dispute-selection-radio-groups' onChange={radioSelection}>
                                    <div>
                                        <div>
                                            <Radio value={'NO_FAVOR'} className='radio-1'>No favor</Radio>
                                        </div>

                                        <div>
                                            <Radio value={'FAVOR_USER'} className='radio-2'>In Favor of Service User</Radio>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <Radio value={'PARTIAL'} className='radio-3' onClick={() => partialModalHandler()}>Partial</Radio>
                                        </div>

                                        <div>
                                            <Radio value={'FAVOR_PROVIDER'} className='radio-4'>In Favor of Service Provider</Radio>
                                        </div>
                                    </div>
                                </Radio.Group>
                                <Button.Basic
                                    disabled={(!radioValue || disputeDetail?.status == 'RESOLVED') ? true : false}
                                    text={'Resolve Dispute'}
                                    className={`${disputeDetail?.status == 'RESOLVED' ? 'resolve-submit-btn' : 'submit-btn'}`}
                                    onClick={disputeHandler}
                                />
                            </div>

                        </Col>

                        <Col span={24} className='detail-subContainer-3'>
                            <div>
                                <div className='disputeAgainst-profile'>
                                    <ProfileImage
                                        asAvatar
                                        src={disputeDetail?.disputeAgainst?.imageUrl}
                                        size={45}
                                    />
                                </div>
                                <div className='disputeAgainst-detail'>
                                    <h3>{disputeDetail?.disputeAgainst?.fullName ? disputeDetail?.disputeAgainst?.fullName : '-'}</h3>
                                    <div className='disputeAgainst-detail-container'>
                                        <div className='disputeagainst-detail-address'>
                                            <div>
                                                <IoLocationSharp color='white' />
                                            </div>
                                            <span>{disputeDetail?.disputeAgainst?.address ? disputeDetail?.disputeAgainst?.address : '-'}</span>
                                        </div>
                                        <div className='disputeagainst-detail-phoneNo'>
                                            <div>
                                                <FaPhoneAlt color='white' />
                                            </div>
                                            <span>{disputeDetail?.disputeAgainst?.phoneNo ? disputeDetail?.disputeAgainst?.phoneNo : '-'}</span>
                                        </div>
                                        <div className='disputeagainst-detail-email'>
                                            <div>
                                                <MdEmail color='white' />
                                            </div>
                                            <span>{disputeDetail?.disputeAgainst?.email ? disputeDetail?.disputeAgainst?.email : '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </>
            }
            {
                partialModal &&
                <Modal.AntDesignModal
                    title=""
                    isModalVisible={partialModal}
                    centered={true}
                    handleCancel={() => {
                        setPartialModal(false);
                    }}
                >
                    <>
                        <Row justify="center">
                            <Col>
                                <Text.Heading
                                    fontSize={24}
                                    fontFamily={Fonts["Poppins-SemiBold"]}
                                    color={Colors.Black}
                                    fontWeight={600}
                                    text={"Set Amount"}
                                />
                            </Col>
                        </Row>
                        <Row justify="center" className="mt-20 flex flex-col">
                            <Col span={24}>
                                <TextField.CustomInput
                                    label="Partial for Service Provider:"
                                    placeholder="Enter Percentage Value"
                                    value={partialValues.sp}
                                    size="large"
                                    type="text"
                                    className="user-subject-field"
                                    onChange={(e) => {
                                        setPartialValues({ ...partialValues, sp: e.target.value })
                                        setPartialValueError({ ...partialValueError, sp: '' })
                                    }}
                                />
                                <Text.Heading
                                    fontSize={14}
                                    fontFamily={Fonts["Poppins-Regular"]}
                                    color={"red"}
                                    fontWeight={400}
                                    text={partialValueError.sp}
                                    textAlign="start"
                                    className="mt-10"
                                />
                            </Col>

                            <Col span={24}>
                                <Text.Heading
                                    fontSize={14}
                                    fontFamily={Fonts["Poppins-Regular"]}
                                    color={""}
                                    fontWeight={400}
                                    text={
                                        <div className='flex items-center partial-modal-note'>
                                            <ImNotification color='red' size={25} />
                                            The percentage value for the service provider or service user must be below 100%
                                        </div>
                                    }
                                    textAlign="start"
                                    className="my-6"
                                />
                            </Col>

                            <Col span={24}>
                                <TextField.CustomInput
                                    label="Partial for Service User:"
                                    placeholder="Enter Percentage Value"
                                    value={partialValues.su}
                                    size="large"
                                    type="text"
                                    className="user-subject-field"
                                    onChange={(e) => {
                                        setPartialValues({ ...partialValues, su: e.target.value })
                                        setPartialValueError({ ...partialValueError, su: '' })
                                    }}
                                />
                                <Text.Heading
                                    fontSize={14}
                                    fontFamily={Fonts["Poppins-Regular"]}
                                    color={"red"}
                                    fontWeight={400}
                                    text={partialValueError.su}
                                    textAlign="start"
                                    className="mt-10"
                                />
                            </Col>
                        </Row>
                        <Row justify="center">
                            <Col span={24}>
                                <Button.Basic
                                    onClick={partialValuesSubmitHandler}
                                    text={"Submit"}
                                    className="dispute-partial-submit-btn"
                                />
                            </Col>
                        </Row>
                    </>

                </Modal.AntDesignModal>
            }

        </Row>
    )
}

export default DisputeDetail